import { render, staticRenderFns } from "./KidsAppUsagesAlerts.vue?vue&type=template&id=2780089c&scoped=true"
import script from "./KidsAppUsagesAlerts.vue?vue&type=script&lang=js"
export * from "./KidsAppUsagesAlerts.vue?vue&type=script&lang=js"
import style0 from "./KidsAppUsagesAlerts.vue?vue&type=style&index=0&id=2780089c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780089c",
  null
  
)

export default component.exports